require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


// require("./vendor/bootstrap-transition");
// require("./vendor/bootstrap-collapse");


(function ($) {

})(jQuery);